import { Component } from '@verndale/core';
import Player from '@vimeo/player';
import YouTubePlayer from 'youtube-player';

class VimeoVideo extends Component {
  setupDefaults() {
    this.videoId = this.el.dataset.videoId;
    this.videoProvider = `${this.el.dataset.videoProvider}`.toLowerCase();
    this.isVideoPlaying = true;
    this.dom = {
      iframeContainer: this.el.querySelector('.vimeo-video__iframe-container'),
      videoProgressBar: this.el.querySelector('.vimeo-video__progress-bar'),
      videoStatusToggle: this.el.querySelector('.vimeo-video__playback-control'),
      videoStatusLabel: this.el.querySelector('.vimeo-video__playback-status-label'),
      videoPauseIcon: this.el.querySelector('.vimeo-video__playback-status-icon .status-icon__pause'),
      videoPlayIcon: this.el.querySelector('.vimeo-video__playback-status-icon .status-icon__play')
    };
    this.setupVideo();
  }

  addListeners() {
    this.dom.videoStatusToggle.addEventListener('click', () => this.onVideoStatusClick())
  }

  cleanIframeAttributes() {
    const iframe = this.dom.iframeContainer.querySelector('iframe');
    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
    iframe.removeAttribute('frameborder');
  }

  setupVideo() {
    if (this.videoProvider === 'vimeo') return this.setupVimeoPlayer();
    if (this.videoProvider === 'youtube') return this.setupYouTubePlayer();
  }

  async setupVimeoPlayer() {
    // If theres no videoId return
    if (!this.videoId) return;
    // Create new vimeo player
    this.vimeoVideoPlayer = new Player(
      this.dom.iframeContainer,
      {
        id: this.videoId,
        autoplay: true,
        background: true,
        controls: false,
        loop: true,
        title: 0
      }
    );
    this.vimeoVideoPlayer.on('play', () => this.cleanIframeAttributes())
    const duration = await this.vimeoVideoPlayer.getDuration();
    // Update video progress bar
    setInterval(async () => {
      const currentTime = await this.vimeoVideoPlayer.getCurrentTime();
      this.dom.videoProgressBar.style.width = `${currentTime * 100 / duration}%`
    }, 300)
  }

  async setupYouTubePlayer() {
    // Create element that will be replaced by the YouTube iframe
    const iframeElement = document.createElement('div');
    this.dom.iframeContainer.append(iframeElement);
    this.youTubePlayer = YouTubePlayer(iframeElement, {
      videoId: this.videoId,
      playerVars: {
        autohide: 1,
        autoplay: 1,
        showinfo: 0,
        controls: 0,
        modestbranding: 1,
        disablekb: 1,
        loop: 1,
        playlist: this.videoId,
        mute: 1,
        fs: 0
      }
    });
    this.youTubePlayer.on('ready', event => this.cleanIframeAttributes());
    const duration = await this.youTubePlayer.getDuration();
    setInterval(async () => {
      const currentTime = await this.youTubePlayer.getCurrentTime();
      this.dom.videoProgressBar.style.width = `${currentTime * 100 / duration}%`
    }, 300);
  }

  pauseVideo() {
    if (this.videoProvider === 'vimeo') return this.vimeoVideoPlayer.pause();
    if (this.videoProvider === 'youtube') return this.youTubePlayer.pauseVideo();
  }

  playVideo() {
    if (this.videoProvider === 'vimeo') return this.vimeoVideoPlayer.play();
    if (this.videoProvider === 'youtube') return this.youTubePlayer.playVideo();
  }

  onVideoStatusClick() {
    // Update label of the video control (ie: play/pause)
    const updateVideoStatusLabel = dataAttr => {
      this.dom.videoStatusLabel.innerText = this.dom.videoStatusToggle.dataset[dataAttr]
    }
    // Update active svg icon
    const updateActiveIcon = status => {
      if (status === 'play') {
        this.dom.videoPlayIcon.classList.add('active');
        this.dom.videoPauseIcon.classList.remove('active');
      } else if (status === 'pause') {
        this.dom.videoPlayIcon.classList.remove('active');
        this.dom.videoPauseIcon.classList.add('active');
      }
    }
    // Handle pause video
    if (this.isVideoPlaying) {
      this.pauseVideo();
      this.isVideoPlaying = false;
      updateVideoStatusLabel('playLabel')
      updateActiveIcon('play');
      // Handle play video
    } else {
      this.playVideo();
      this.isVideoPlaying = true;
      updateVideoStatusLabel('pauseLabel');
      updateActiveIcon('pause');
    }
  }
}

export default VimeoVideo;
